import {
    CreateSalesOrderInput,
    GetPurchaseOrderExtractionDraftInput,
    GetPurchaseOrderExtractionDraftOutput,
    ListDocumentExtractionsInput,
    ListDocumentExtractionsOutput,
    RequestDocumentUploadUrlInput,
    RequestDocumentUploadUrlOutput,
    StartDocumentExtractionInput,
    StartDocumentExtractionOutput,
    UpdateDocumentExtractionStatusInput,
} from '../types';
import { Logger } from '../utils/logger';
import { HrpsApiClient } from './HrpsApiClient';

export const requestDocumentUploadUrl = async (
    requestDocumentUploadUrlInput: RequestDocumentUploadUrlInput
): Promise<RequestDocumentUploadUrlOutput> => {
    Logger.info('Requesting Upload Url', requestDocumentUploadUrlInput);
    return await new HrpsApiClient()
        .callHrps('requestDocumentUploadUrl', requestDocumentUploadUrlInput)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error getting document upload URL: ', error.message);
            throw error;
        });
};

export const startDocumentExtraction = async (
    startDocumentExtractionInput: StartDocumentExtractionInput
): Promise<StartDocumentExtractionOutput> => {
    Logger.info('Starting Document Extraction', startDocumentExtractionInput);
    return await new HrpsApiClient()
        .callHrps('startDocumentExtraction', startDocumentExtractionInput)
        .then((response) => {
            Logger.debug(response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error starting document extraction: ', error.message);
            throw error;
        });
};

export const listDocumentExtractions = async (
    listDocumentExtractionsInput: ListDocumentExtractionsInput
): Promise<ListDocumentExtractionsOutput> => {
    Logger.info('Listing Document Extractions', listDocumentExtractionsInput);
    return await new HrpsApiClient()
        .callHrps('listDocumentExtractions', listDocumentExtractionsInput)
        .then((response) => {
            Logger.debug(response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error listing extractions: ', error.message);
            throw error;
        });
};

export const getPurchaseOrderExtractionDraft = async (
    getPurchaseOrderExtractionDraftInput: GetPurchaseOrderExtractionDraftInput
): Promise<GetPurchaseOrderExtractionDraftOutput> => {
    Logger.info('Getting Purchase Order Extraction Draft', getPurchaseOrderExtractionDraftInput);
    return await new HrpsApiClient()
        .callHrps('getPurchaseOrderExtractionDraft', getPurchaseOrderExtractionDraftInput)
        .then((response) => {
            Logger.debug('Purchase order extraction draft', response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error getting purchase order extraction draft: ', error.message);
            throw error;
        });
};

export const updateDocumentExtractionStatus = async (
    updateDocumentExtractionStatusInput: UpdateDocumentExtractionStatusInput
): Promise<void> => {
    Logger.info('Updating Document Extraction Status', updateDocumentExtractionStatusInput);
    return await new HrpsApiClient()
        .callHrps('updateDocumentExtractionStatus', updateDocumentExtractionStatusInput)
        .then((response) => {
            Logger.debug(response.data);
        })
        .catch((error) => {
            Logger.debug('Error updating document extraction status: ', error.message);
            throw error;
        });
};

export const createSalesOrder = async (createSalesOrderInput: CreateSalesOrderInput): Promise<void> => {
    Logger.info('Creating sales order', createSalesOrderInput);
    return await new HrpsApiClient()
        .callHrps('createSalesOrder', createSalesOrderInput)
        .then((response) => {
            Logger.debug(response.data);
        })
        .catch((error) => {
            Logger.debug('Error creating purchase order: ', error.message);
            throw error;
        });
};
